import { killClone } from './clone';
import { handleLogedOut } from './handler';
import { generateInvoice } from './events';
export { showLoginModal, showOrderModal };

function showLoginModal() {
	if (window.innerWidth < 769) {
		$("html, body").animate({
			scrollTop: 0
		}, 300);

		if (!$("body").hasClass("menu-open")) {
			$("body").addClass("overflow-hidden");
		}
	}

	$("#login-modal").show();
}

function showOrderModal(currentEventTarget, currentEventDataset, totalPrice) {
	if (USER_ID > 0) {
		var workplaceHandle = function workplaceHandle(e) {
			var isInputLocked = document.querySelector(".isikukood").classList.contains("lock");

			if (!isInputLocked) {
				idCodeListener();
			}
		};

		var idCodeListener = function idCodeListener() {
			document.querySelector("input[data-input='isikukood']").addEventListener('input', function (e) {
				var idCode = this.value;
				var errorNote = document.querySelector(".error-note");
				console.log(this);
				var parent = this.parentElement;

				function waitForIt() {
					parent.classList.remove("locked");
					parent.focus();
				}

				if (idCode.length > 10) {
					idCode = idCode.slice(0, 11);
					parent.classList.add("locked");
					parent.blur();
					$.ajax({
						url: WWW_URL + '/check_ik/' + idCode,
						success: function success(data) {
							console.log(data);
							var idCheckers = $.parseJSON(data);

							if (idCheckers.status === "ok" || idCheckers.status === "warning") {
								console.log(idCheckers);

								if (workplace.size > 0) {
									totalPrice = parseFloat(document.querySelector(".total-price").innerHTML) + lisatookohtPrice;
									document.querySelector(".total-price").innerHTML = parseFloat(totalPrice).toFixed(2);
								}

								if (!workplace.has(this.value)) {
									workplace.add(idCode);

									if (errorNote) {
										errorNote.parentNode.removeChild(errorNote);
									}

									document.querySelector(".payment-btn").classList.remove("locked");
									document.querySelector("input[data-input='isikukood']").classList.add("locked-success");
									document.querySelector(".tookoht-price").classList.remove("locked");
									document.querySelector(".tookoht-price").classList.remove("tookoht-price");
									var idCodeSelctor = document.querySelector("input[data-input='isikukood']");
									idCodeSelctor.blur();
									idCodeSelctor.setAttribute("data-input", idCode);
									var deleteId = document.createElement("button");
									deleteId.setAttribute("data-delete", idCode);
									deleteId.classList.add("fa");
									deleteId.classList.add("fa-trash");
									var isikukood = document.createElement("input");
									isikukood.setAttribute("type", "number");
									isikukood.setAttribute("data-input", "isikukood");
									isikukood.classList.add("isikukood");
									document.querySelector(".delete-id").appendChild(deleteId);
									document.querySelector(".delete-id").classList.remove("delete-id");
									var newCard = document.createElement('section');
									newCard.className = "large-12 cell lisa-tookoht nowrap grid-x";
									newCard.innerHTML += '<section class="large-7 isikukoodid  service-content cell">' + '<input class="isikukood" type="number" data-input="isikukood">' + '</section>' + '<section class="large-1 service-content delete-id  cell"></section>' + '<section class="large-3 price service-content cell"><span class="cacl-price tookoht-price locked">' + lisatookohtPrice + ' €</span> </section>';
									document.querySelector(".input-field").appendChild(newCard);
									var input = document.querySelector('input[data-input="' + idCode + '"]');
									var isikukoodidNode = input.parentNode.parentNode;
									isikukoodidNode.classList.add("isikukoodid-" + idCode);
									waitForIt();

									if (idCheckers.status === "warning") {
										var warrningNote = document.createElement("span");
										warrningNote.innerHTML = idCheckers.message;
										warrningNote.classList.add("id-has-packet");
										input.parentNode.appendChild(warrningNote);
									}

									document.querySelector('button[data-delete="' + idCode + '"]').addEventListener('click', function (e) {
										e.preventDefault();
										var thisIsCode = this.dataset.delete;
										console.log(this.dataset.delete);
										workplace.delete(thisIsCode);
										var del = document.querySelector('button[data-delete="' + thisIsCode + '"]');
										var inp = document.querySelector('input[data-input="' + thisIsCode + '"]');
										del.parentNode.removeChild(del);
										inp.parentNode.removeChild(inp);
										isikukoodidNode.parentNode.removeChild(isikukoodidNode);
										totalPrice = parseFloat(document.querySelector(".total-price").innerHTML) - lisatookohtPrice;
										document.querySelector(".total-price").innerHTML = parseFloat(totalPrice).toFixed(2);
										workplace.delete(idCode);
										calcTax(totalPrice);
									});
									workplaceHandle(e);
									calcTax(totalPrice);
								} else {
									idCode = idCode.slice(0, 11);
									waitForIt();

									if (errorNote) {
										errorNote.innerHTML = "Isikukood on juba sisestatud";
										erroeNote.classList.add("warning");
										erroeNote.classList.remove("danger");
									} else {
										var _erroeNote = document.createElement("section");

										_erroeNote.classList.add("warning");

										_erroeNote.classList.add("grin-x");

										_erroeNote.classList.add("large-12");

										_erroeNote.classList.add("error-note");

										_erroeNote.innerHTML = "Isikukood on juba sisestatud";
										document.querySelector(".lisa-tookoht-wrapper").appendChild(_erroeNote);
									}
								}
							} else {
								waitForIt();

								if (errorNote) {
									errorNote.innerHTML = idCheckers.message;
									erroeNote.classList.add("warning");
									erroeNote.classList.remove("danger");
								} else {
									var _erroeNote2 = document.createElement("section");

									_erroeNote2.classList.add("warning");

									_erroeNote2.classList.add("grin-x");

									_erroeNote2.classList.add("large-12");

									_erroeNote2.classList.add("error-note");

									_erroeNote2.innerHTML = idCheckers.message;
									document.querySelector(".lisa-tookoht-wrapper").appendChild(_erroeNote2);
								}
							}
						}
					});
				} else if (idCode.length < 11) {
					var _errorNote = document.querySelector(".error-note");

					if (_errorNote) {
						_errorNote.parentNode.removeChild(_errorNote);
					}
				}
			});
		};

		var getLinks = function getLinks(order) {
			var swed = order.links.swed;
			var seb = order.links.seb;
			var lhv = order.links.lhv;
			var coop = order.links.coop;
			var invoice = order.links.invoice;
			var slogan = order.slogan;
			var total = order.total;
			document.querySelector('a[data-bank="swed"]').setAttribute("href", swed);
			document.querySelector('a[data-bank="lhv"]').setAttribute("href", lhv);
			document.querySelector('a[data-bank="seb"]').setAttribute("href", seb);
			document.querySelector('a[data-bank="coop"]').setAttribute("href", coop);
			// document.querySelector('a[data-bank="invoice"]').setAttribute("onclick", "generateInvoice(event,'" + invoice + "')");
			document.querySelector('a[data-bank="invoice"]').addEventListener('click', (event) => {
				generateInvoice(event, invoice);
			})
			document.querySelector('.slogan').innerHTML = slogan + "</br> Kokku: " + total + " €";
			document.querySelector(".mainOrder").classList.add("hide");
			document.querySelector(".tasumine").classList.remove("hide-important");
		};

		var calcTax = function calcTax(totalPrice) {
			console.log("totalPrice: ", totalPrice, "| km: ", km, "| withKM: ", withKM, "| KM_SIZE:", KM_SIZE, "%");
			var km = totalPrice * (KM_SIZE / 100);
			var withKM = totalPrice + km;
			km = km.toFixed(2);
			withKM = withKM.toFixed(2);
			document.querySelector(".total-km").innerHTML = km;
			document.querySelector(".total-with-km").innerHTML = withKM;
			console.log("totalPrice: ", totalPrice, "| km: ", km, "| withKM: ", withKM, "| KM_SIZE:", KM_SIZE, "%");
		};
		/*$("#orderModal").show();*/


		console.log(currentEventTarget, currentEventDataset);
		totalPrice = 0.00;
		/* Service Prices */

		var ukoPrice = document.querySelector(".uko-akteveerimine-price");
		var soilPrice = document.querySelector(".soil-akteveerimine-price");
		var restrictionsPrice = document.querySelector(".restrictions-akteveerimine-price");
		var provisionsPrice = document.querySelector(".provisions-akteveerimine-price");
		var eagentPrice = document.querySelector(".eagent-price");
		var lisatookohtPrice = document.querySelector(".tookoht-price");
		/* PACKET Prices*/

		var bronzePrice = parseFloat(document.querySelector(".bronze-price").innerHTML);
		var silverPrice = parseFloat(document.querySelector(".silver-price").innerHTML);
		var goldPrice = parseFloat(document.querySelector(".gold-price").innerHTML);
		var pakage = "";
		var extra = new Set([]);
		var workplace = new Set([]);

		if (ukoPrice) {
			ukoPrice = parseFloat(document.querySelector(".uko-akteveerimine-price").innerHTML);
		}

		if (soilPrice) {
			soilPrice = parseFloat(document.querySelector(".soil-akteveerimine-price").innerHTML);
		}

		if (restrictionsPrice) {
			restrictionsPrice = parseFloat(document.querySelector(".restrictions-akteveerimine-price").innerHTML);
		}

		if (provisionsPrice) {
			provisionsPrice = parseFloat(document.querySelector(".provisions-akteveerimine-price").innerHTML);
		}

		if (eagentPrice) {
			eagentPrice = parseFloat(document.querySelector(".eagent-price").innerHTML);
		}

		if (document.querySelector(".tookoht-price")) {
			lisatookohtPrice = parseFloat(document.querySelector(".tookoht-price").innerHTML);
		}

		document.querySelector(".mainOrder").classList.remove("hide");
		document.querySelector(".tasumine").classList.add("hide-important");
		document.querySelector(".total-price").innerHTML = totalPrice;

		if (currentEventTarget.contains('bronze-btn')) {
			totalPrice = 0.00;
			document.querySelector(".selection1").classList.remove("hide");
			document.querySelector(".selection3").classList.add("hide");
			document.querySelector(".selection2").classList.add("hide");
			document.querySelector(".valitud-paket").classList.remove("hide");
			totalPrice = parseFloat(document.querySelector(".total-price").innerHTML) + bronzePrice;
			document.querySelector(".total-price").innerHTML = parseFloat(totalPrice).toFixed(2);
			document.querySelector(".payment-btn").classList.remove("locked");
			pakage = "bronze";
			calcTax(totalPrice);
		} else if (currentEventTarget.contains('silver-btn')) {
			totalPrice = 0.00;
			document.querySelector(".selection2").classList.remove("hide");
			document.querySelector(".selection1").classList.add("hide");
			document.querySelector(".selection3").classList.add("hide");
			document.querySelector(".valitud-paket").classList.remove("hide");
			totalPrice = parseFloat(document.querySelector(".total-price").innerHTML) + silverPrice;
			document.querySelector(".total-price").innerHTML = parseFloat(totalPrice).toFixed(2);
			document.querySelector(".payment-btn").classList.remove("locked");
			calcTax(totalPrice);
			pakage = "silver";
		} else if (currentEventTarget.contains('gold-btn')) {
			totalPrice = 0.00;
			ukoPrice = 0.00;
			document.querySelector(".uko-akteveerimine-price").innerHTML = 0.00;
			document.querySelector(".selection3").classList.remove("hide");
			document.querySelector(".selection1").classList.add("hide");
			document.querySelector(".selection2").classList.add("hide");
			document.querySelector(".valitud-paket").classList.remove("hide");
			document.querySelector(".uko").classList.add("locked");
			document.querySelector("#uko-akteveerimine").checked = true;
			document.querySelector("#uko-akteveerimine").classList.add("locked");
			totalPrice = parseFloat(document.querySelector(".total-price").innerHTML) + goldPrice;
			document.querySelector(".total-price").innerHTML = parseFloat(totalPrice).toFixed(2);
			document.querySelector(".payment-btn").classList.remove("locked");
			pakage = "gold";
			calcTax(totalPrice);
		} else {
			totalPrice = 0.00;
			document.querySelector(".valitud-paket").classList.add("hide");
			calcTax(totalPrice);

			if (currentEventDataset.service === "lisatookoht") {
				totalPrice = 0.00;
				document.querySelector("#lisa-tookoht").checked = true;
				document.querySelector(".lisa-tookoht").classList.remove("locked");
				document.querySelector(".isikukood").style.visibility = "visible";
				totalPrice = parseFloat(document.querySelector(".total-price").innerHTML) + lisatookohtPrice;
				document.querySelector(".total-price").innerHTML = parseFloat(totalPrice).toFixed(2);
				workplaceHandle();
				calcTax(totalPrice);
			} else if (currentEventDataset.service === "uko") {
				totalPrice = 0.00;
				document.querySelector("#uko-akteveerimine").checked = true;
				document.querySelector(".uko").classList.remove("locked");
				totalPrice = parseFloat(document.querySelector(".total-price").innerHTML) + ukoPrice;
				document.querySelector(".total-price").innerHTML = parseFloat(totalPrice).toFixed(2);
				document.querySelector(".payment-btn").classList.remove("locked");
				extra.add("uko");
				calcTax(totalPrice);
			} else if (currentEventDataset.service === "soil") {
				totalPrice = 0.00;
				document.querySelector("#soil-akteveerimine").checked = true;
				document.querySelector(".soil").classList.remove("locked");
				totalPrice = parseFloat(document.querySelector(".total-price").innerHTML) + soilPrice;
				document.querySelector(".total-price").innerHTML = parseFloat(totalPrice).toFixed(2);
				document.querySelector(".payment-btn").classList.remove("locked");
				extra.add("soil");
				calcTax(totalPrice);
			} else if (currentEventDataset.service === "restrictions") {
				totalPrice = 0.00;
				document.querySelector("#restrictions-akteveerimine").checked = true;
				document.querySelector(".restrictions").classList.remove("locked");
				totalPrice = parseFloat(document.querySelector(".total-price").innerHTML) + restrictionsPrice;
				document.querySelector(".total-price").innerHTML = parseFloat(totalPrice).toFixed(2);
				document.querySelector(".payment-btn").classList.remove("locked");
				extra.add("restrictions");
				calcTax(totalPrice);
			} else if (currentEventDataset.service === "provisions") {
				totalPrice = 0.00;
				document.querySelector("#provisions-akteveerimine").checked = true;
				document.querySelector(".provisions").classList.remove("locked");
				totalPrice = parseFloat(document.querySelector(".total-price").innerHTML) + provisionsPrice;
				document.querySelector(".total-price").innerHTML = parseFloat(totalPrice).toFixed(2);
				document.querySelector(".payment-btn").classList.remove("locked");
				extra.add("provisions");
				calcTax(totalPrice);
			} else if (currentEventDataset.service === "manuaalne-eagent") {
				totalPrice = 0.00;
				document.querySelector("#manualne-eagent").checked = true;
				document.querySelector(".eagent").classList.remove("locked");
				totalPrice = parseFloat(document.querySelector(".total-price").innerHTML) + eagentPrice;
				document.querySelector(".total-price").innerHTML = parseFloat(totalPrice).toFixed(2);
				document.querySelector(".payment-btn").classList.remove("locked");
				extra.add("eagent");
				calcTax(totalPrice);
			} else {
				console.log(currentEventDataset);
			}
		}

		if (document.querySelector("#lisa-tookoht")) {
			document.querySelector("#lisa-tookoht").addEventListener("click", function () {
				if (document.querySelector("#lisa-tookoht").checked === true) {
					document.querySelector(".lisa-tookoht").classList.remove("locked");
					totalPrice = parseFloat(document.querySelector(".total-price").innerHTML) + lisatookohtPrice;
					document.querySelector(".total-price").innerHTML = parseFloat(totalPrice).toFixed(2);
					document.querySelector(".isikukood").style.visibility = "visible";
					workplaceHandle();
					calcTax(totalPrice);
				} else if (document.querySelector("#lisa-tookoht").checked === false) {
					document.querySelector(".lisa-tookoht").classList.add("locked");
					totalPrice = parseFloat(document.querySelector(".total-price").innerHTML) - lisatookohtPrice;
					document.querySelector(".total-price").innerHTML = parseFloat(totalPrice).toFixed(2);
					document.querySelector(".isikukood").style.visibility = "hidden";
					calcTax(totalPrice);
				}
			});
		}

		if (document.querySelector("#uko-akteveerimine")) {
			document.querySelector("#uko-akteveerimine").addEventListener("click", function () {
				if (document.querySelector("#uko-akteveerimine").checked === true) {
					document.querySelector(".uko").classList.remove("locked");
					totalPrice = parseFloat(document.querySelector(".total-price").innerHTML) + ukoPrice;
					document.querySelector(".payment-btn").classList.remove("locked");
					document.querySelector(".total-price").innerHTML = parseFloat(totalPrice).toFixed(2);
					extra.add("uko");
					calcTax(totalPrice);
				} else if (document.querySelector("#uko-akteveerimine").checked === false) {
					document.querySelector(".uko").classList.add("locked");
					totalPrice = parseFloat(document.querySelector(".total-price").innerHTML) - ukoPrice;
					document.querySelector(".total-price").innerHTML = parseFloat(totalPrice).toFixed(2);
					extra.delete("uko");
					calcTax(totalPrice);
				}
			});
		}

		if (document.querySelector("#soil-akteveerimine")) {
			document.querySelector("#soil-akteveerimine").addEventListener("click", function () {
				if (document.querySelector("#soil-akteveerimine").checked === true) {
					document.querySelector(".soil").classList.remove("locked");
					totalPrice = parseFloat(document.querySelector(".total-price").innerHTML) + soilPrice;
					document.querySelector(".payment-btn").classList.remove("locked");
					document.querySelector(".total-price").innerHTML = parseFloat(totalPrice).toFixed(2);
					extra.add("soil");
					calcTax(totalPrice);
				} else if (document.querySelector("#soil-akteveerimine").checked === false) {
					document.querySelector(".soil").classList.add("locked");
					totalPrice = parseFloat(document.querySelector(".total-price").innerHTML) - soilPrice;
					document.querySelector(".total-price").innerHTML = parseFloat(totalPrice).toFixed(2);
					extra.delete("soil");
					calcTax(totalPrice);
				}
			});
		}

		if (document.querySelector("#restrictions-akteveerimine")) {
			document.querySelector("#restrictions-akteveerimine").addEventListener("click", function () {
				if (document.querySelector("#restrictions-akteveerimine").checked === true) {
					document.querySelector(".restrictions").classList.remove("locked");
					totalPrice = parseFloat(document.querySelector(".total-price").innerHTML) + restrictionsPrice;
					document.querySelector(".payment-btn").classList.remove("locked");
					document.querySelector(".total-price").innerHTML = parseFloat(totalPrice).toFixed(2);
					extra.add("restrictions");
					calcTax(totalPrice);
				} else if (document.querySelector("#restrictions-akteveerimine").checked === false) {
					document.querySelector(".restrictions").classList.add("locked");
					totalPrice = parseFloat(document.querySelector(".total-price").innerHTML) - restrictionsPrice;
					document.querySelector(".total-price").innerHTML = parseFloat(totalPrice).toFixed(2);
					extra.delete("restrictions");
					calcTax(totalPrice);
				}
			});
		}

		if (document.querySelector("#provisions-akteveerimine")) {
			document.querySelector("#provisions-akteveerimine").addEventListener("click", function () {
				if (document.querySelector("#provisions-akteveerimine").checked === true) {
					document.querySelector(".provisions").classList.remove("locked");
					totalPrice = parseFloat(document.querySelector(".total-price").innerHTML) + provisionsPrice;
					document.querySelector(".payment-btn").classList.remove("locked");
					document.querySelector(".total-price").innerHTML = parseFloat(totalPrice).toFixed(2);
					extra.add("provisions");
					calcTax(totalPrice);
				} else if (document.querySelector("#provisions-akteveerimine").checked === false) {
					document.querySelector(".provisions").classList.add("locked");
					totalPrice = parseFloat(document.querySelector(".total-price").innerHTML) - provisionsPrice;
					document.querySelector(".total-price").innerHTML = parseFloat(totalPrice).toFixed(2);
					extra.delete("provisions");
					calcTax(totalPrice);
				}
			});
		}

		if (document.querySelector("#manualne-eagent")) {
			document.querySelector("#manualne-eagent").addEventListener("click", function () {
				if (document.querySelector("#manualne-eagent").checked === true) {
					document.querySelector(".eagent").classList.remove("locked");
					totalPrice = parseFloat(document.querySelector(".total-price").innerHTML) + eagentPrice;
					document.querySelector(".payment-btn").classList.remove("locked");
					document.querySelector(".total-price").innerHTML = parseFloat(totalPrice).toFixed(2);
					extra.add("eagent");
					console.log(extra);
					calcTax(totalPrice);
				} else if (document.querySelector("#manualne-eagent").checked === false) {
					document.querySelector(".eagent").classList.add("locked");
					totalPrice = parseFloat(document.querySelector(".total-price").innerHTML) - eagentPrice;
					document.querySelector(".total-price").innerHTML = parseFloat(totalPrice).toFixed(2);
					extra.delete("eagent");
					calcTax(totalPrice);
				}
			});
		}

		var paymentBtn = document.querySelector(".payment-btn");

		var _clone = paymentBtn.cloneNode(true);

		document.querySelector(".mainOrder").appendChild(_clone);
		paymentBtn.parentNode.removeChild(paymentBtn);

		_clone.addEventListener("click", function handlePayment() {
			var pakages = "";
			var extras = "";
			var workplaces = "";

			if (pakage !== "") {
				pakages = "&package=" + pakage;
			}

			extra.forEach(function (element) {
				extras = extras + "&extras[]=" + element;
			});
			workplace.forEach(function (element) {
				workplaces = workplaces + "&workplace[]=" + element;
			});
			var link = "?f=kaardirakendus&preview=1" + pakages + extras + workplaces;
			console.log(link);

			if (pakage !== "" || extras !== [] || workplaces !== []) {
				$.ajax({
					url: WWW_INDEX + link,
					success: function success(data) {
						var order = $.parseJSON(data);
						getLinks(order);
					}
				});
			}

			return false;
		}, {
			once: true
		});

		var overlay = document.querySelector("#orderModal");
		overlay.style.display = "flex";
	} else {
		$(".cta-login").show();

		if (currentEventTarget.contains('bronze-btn')) {
			sessionStorage.setItem('service', 'bronze');
		} else if (currentEventTarget.contains('silver-btn')) {
			sessionStorage.setItem('service', 'silver');
		} else if (currentEventTarget.contains('gold-btn')) {
			sessionStorage.setItem('service', 'gold');
		} else {
			if (currentEventDataset.service === "lisatookoht") {
				sessionStorage.setItem('service', 'lisatookoht');
			} else if (currentEventDataset.service === "uko") {
				sessionStorage.setItem('service', 'uko');
			} else if (currentEventDataset.service === "soil") {
				sessionStorage.setItem('service', 'soil');
			} else if (currentEventDataset.service === "restrictions") {
				sessionStorage.setItem('service', 'restrictions');
			} else if (currentEventDataset.service === "provisions") {
				sessionStorage.setItem('service', 'provisions');
			} else if (currentEventDataset.service === "manuaalne-eagent") {
				sessionStorage.setItem('service', 'manuaalne-eagent');
			} else {
				console.log(currentEventDataset);
			}
		}

		handleLogedOut(currentEventTarget, currentEventDataset);
	}
}

if (document.querySelector("#orderModal")) {
	var overlay = document.querySelector("#orderModal");
	overlay.addEventListener('click', function (e) {
		console.log(e);

		if (e.target === overlay) {
			if ($(".popup-overlay").is(":visible")) {
				$(".popup-overlay").hide();
				killClone();
			}
		}
	});
}